module.exports = __webpack_public_path__ + "img/arrowUp.f89b5d4e.svg";